import * as PIXI from "pixi.js";
import { EventHandler } from "../../../util/event/EventHandler";
/**
 * SnapDirection.ts
 */
export var SnapDirection;
(function (SnapDirection) {
    SnapDirection[SnapDirection["NORTH"] = 0] = "NORTH";
    SnapDirection[SnapDirection["NORTH_EAST"] = 1] = "NORTH_EAST";
    SnapDirection[SnapDirection["EAST"] = 2] = "EAST";
    SnapDirection[SnapDirection["SOUTH_EAST"] = 3] = "SOUTH_EAST";
    SnapDirection[SnapDirection["SOUTH"] = 4] = "SOUTH";
    SnapDirection[SnapDirection["SOUTH_WEST"] = 5] = "SOUTH_WEST";
    SnapDirection[SnapDirection["WEST"] = 6] = "WEST";
    SnapDirection[SnapDirection["NORTH_WEST"] = 7] = "NORTH_WEST";
})(SnapDirection || (SnapDirection = {}));
/*
 * SnapLayout.ts
 */
export class SnapLayout {
    constructor(target, direction) {
        this.target = target;
        this.position = new PIXI.Point(target.x, target.y);
        this.direction = direction;
        this.createHandler(direction);
    }
    equals(other) {
        return this.position.equals(other.position) &&
            (this.direction === other.direction);
    }
    createHandler(direction) {
        let action = this.getAction(direction);
        this.handler = new EventHandler(action, this);
    }
    snap(transform) {
        this.handler.call(transform);
    }
    north(safeTransform) {
        this.target.position.y = this.position.y + safeTransform.y;
    }
    east(safeTransform) {
        this.target.position.x = this.position.x + safeTransform.x;
    }
    south(safeTransform) {
        this.target.position.y = this.position.y - safeTransform.y;
    }
    west(safeTransform) {
        this.target.position.x = this.position.x - safeTransform.x;
    }
    northEast(safeTransform) {
        this.north(safeTransform);
        this.east(safeTransform);
    }
    southEast(safeTransform) {
        this.south(safeTransform);
        this.east(safeTransform);
    }
    southWest(safeTransform) {
        this.south(safeTransform);
        this.west(safeTransform);
    }
    northWest(safeTransform) {
        this.north(safeTransform);
        this.west(safeTransform);
    }
    getAction(direction) {
        let action;
        if (direction == SnapDirection.NORTH) {
            action = this.north;
        }
        else if (direction == SnapDirection.NORTH_EAST) {
            action = this.northEast;
        }
        else if (direction == SnapDirection.EAST) {
            action = this.east;
        }
        else if (direction == SnapDirection.SOUTH_EAST) {
            action = this.southEast;
        }
        else if (direction == SnapDirection.SOUTH) {
            action = this.south;
        }
        else if (direction == SnapDirection.SOUTH_WEST) {
            action = this.southWest;
        }
        else if (direction == SnapDirection.WEST) {
            action = this.west;
        }
        else if (direction == SnapDirection.NORTH_WEST) {
            action = this.northWest;
        }
        return action;
    }
}
//# sourceMappingURL=SnapLayout.js.map